import { gql } from "@apollo/client";

export const GET_ALL_ESTADO_MEDICO = gql`
query GetAllEstadoCondicionalMedico {
    allEstadoCondicionalMedico {
        idEstadoCondicionalMedico
        descripcion
    }
}
`;

export const adaptEstadoMedico = (estadoMedico) => {
  return {
    id: estadoMedico?.idEstadoCondicionalMedico,
    displayName: estadoMedico?.descripcion
  };
};

export const adaptEstadoMedicoArray = (
allEstadoCondicionalMedico) =>
{
  return structuredClone(allEstadoCondicionalMedico)?.
  map((estadoMedico) => adaptEstadoMedico(estadoMedico));
};